export default __webpack_public_path__ + "static/mobilepay-da3a7a4821603189d2101f9697fc37d9.png";